export const getDateTags = (startDate: string | null, endDate: string | null, type: 'note' | 'card' | 'review' = 'note'): string[] => {
    const tags = new Set<string>();
  
    if (!startDate) return Array.from(tags);
  
    const start = new Date(startDate);
    let end: Date;

    if (type === 'review') {
        // For reviews, use the start date as the end date to only generate tags for that specific date
        end = new Date(startDate);
    } else {
        // For other types, use the existing logic
        end = endDate ? new Date(endDate) : new Date();
        
        // Adjust end date for ongoing projects (only for non-review items)
        const today = new Date();
        if (!endDate || end > today) {
            end.setDate(today.getDate() + 1); // Using tomorrow for ongoing projects
        }
    }
  
    for (let d = new Date(start); d <= end; d.setMonth(d.getMonth() + 1)) {
        const year = d.getFullYear();
        tags.add(year.toString());
    
        const month = d.getMonth();
        const half = month < 6 ? 'H1' : 'H2';
        tags.add(`${half} ${year}`);
    
        const quarter = Math.floor(month / 3) + 1;
        tags.add(`Q${quarter} ${year}`);
    }
  
    // Only add status tags for cards
    if (type === 'card') {
        const today = new Date();
        tags.add(endDate && new Date(endDate) < today ? 'Completed' : 'In Progress');
    }
  
    return Array.from(tags);
};